import React from 'react';
import Checkbox from '@uiParts/checkbox';

type Props = {
  isOutputToReport: boolean;
  onToggle: () => void;
};

/**
 * Checkbox for "案件報告書に出力する".
 * Injected into editHistoryModal via ComponentExtensionRegistry at 'workHistory.modal.extras'.
 * Receives isOutputToReport state and onToggle from the modal via props.
 */
const OutputToReportCheckbox: React.FC<Props> = ({ isOutputToReport, onToggle }) => {
  return (
    <Checkbox
      checked={isOutputToReport}
      onChange={onToggle}
      title="案件報告書に出力する"
    />
  );
};

export default OutputToReportCheckbox;
